import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { InputSelect2, InputBasicText } from '../common/Inputs';
import { RayCodeAction } from '../../actions/RayCodeAction';
import DatePicker from "react-datepicker";
import { ProductConstant } from '../../actions/constants/ProductConstant';
import DeepSearchFilterSave from './DeepSearchFilterSave';
import { AdminUserAction, AuthAction, CompanyAction, ProductPartAction } from '../../actions';
import { RayDelButton } from './Buttons';
import { CountryCode } from '../../config';
import { RayStatuses } from '../../config/RayCodes';
import { Translate as t } from '../../config/Translate';

export const resolveOperatorValStr = (list, selval) => {
	const op = (list || []).filter(x => x.code == selval);
	return op[0]?.title ?? selval;
};

const DeepSearch = ({ filterData, nowuserfilter, defaultFilter, callbackDs, callbackDSClose, savefiltertype = "product",
	UpdateUserAdminFilters, user, callbackchangeuserfilter, companies, users, GetUserAll, GetPartAll, clist,
	dispatchType = ProductConstant.UPDATE_DSFILTER, partitems,
	extratrakey, extratrakeyname, dsfilters }) => {

	const [showModal, setShowModal] = useState(false);
	const [options, setOptions] = useState([]);
	const [operators, setOperators] = useState([]);
	const [adminusers, setAdminUsers] = useState([]);
	const [allfilter, setAllFilter] = useState([]);
	const [seloptions, setSelOptions] = useState({});
	const [selval, setSelVal] = useState("");
	const [prdOptionList, setPrdOptionList] = useState([]);
	const [selprdoption, setSelPrdOption] = useState("");
	const [selcountry, setSelCountry] = useState("");
	const [selpartlist, setSelPartList] = useState([]);
	const [selclaim, setSelClaim] = useState("");
	const [fixListItem, setFixListItem] = useState([]);
	const [selFixListItem, setSelFixListItem] = useState("");
	const [parts, setParts] = useState([]);
	const [claims, setClaims] = useState([]);
	const [seluser, setSelUser] = useState("");
	const [selstatus, setSelStatus] = useState("");
	const [seloperator, setSelOperator] = useState("");
	const [selvaltf, setSelValTF] = useState(true);
	const [valtype, setValType] = useState("STRING");
	const [filter, setFilter] = useState(Array.isArray(dsfilters) ? dsfilters : []); // BUG-157: 비배열 가드
	const [codeList, setCodeList] = useState([]);
	const [dtOptionVal, setDtOptionVal] = useState({ opt: "last", lastVal: 7, lastValOpt: "d" });
	const dispatch = useDispatch();
	const [warOptionList, setWarOptionList] = useState([]);
	const [selwarranty, setWarranty] = useState("");
	const [warProductList, setWarProductList] = useState([]);
	const [selwarrantyproduct, setWarrantyProduct] = useState("");

	useEffect(() => {
		setAllFilter(Array.isArray(user.filters) ? user.filters : []);
	}, [user.filters]);

	useEffect(() => {
		setCodes();
	}, [clist]);

	useEffect(() => {
		if (partitems.length == 0) {
			GetPartAll();
		} else {
			const clist = []
			partitems.map(x => clist.filter(y => y.code == x.type).length > 0 || clist.push({ code: x.type, title: x.type }))
			setParts(clist);
		}
	}, [partitems]);

	useEffect(() => {
		if (users.length == 0) {
			GetUserAll();
		} else {
			const clist = []
			users.map(x => clist.push({ code: x.adminid, title: x.adminid }))
			setAdminUsers(clist);
		}
	}, [users]);

	useEffect(() => {
		if (companies.length == 0) {
			//GetCompany();
		} else {
			// IMP-370: operator 필터 드롭다운 회사명 오름차순 정렬(RayTable OPERATOR 필터 전반).
			const clist = companies.map(x => ({ code: x.companyId, title: x.name }))
				.sort((a, b) => (a.title || '').localeCompare(b.title || ''));
			setOperators(clist);
		}
	}, [companies]);

	useEffect(() => {
		Array.isArray(nowuserfilter.filter) && setFilter(nowuserfilter.filter); // BUG-157: 비배열 가드 (filter state 재대입 경로)
	}, [nowuserfilter]);

	useEffect(() => {
		const oList = []
		codeList.map(x => {
			oList.push({ code: x.code, title: x.name });
		});
		setOptions(oList);
	}, [codeList]);

	const setCodes = async () => {
		const codes = Array.isArray(clist) ? clist : []; // BUG-157: 비배열 가드
		const cList = [];
		const citems = codes.filter(x => x.type === 'CLAIMTYPE'); // await RayCodeAction.GetAllByFilter({ type: "CLAIMTYPE" });
		citems.filter(x => cList.filter(y => y.code == x.group).length > 0 || cList.push({ code: x.group, title: x.group }));
		setClaims(cList);

		const filterList = [...defaultFilter];
		//var extradataList = await RayCodeAction.GetAllByFilter({ type : extratrakey });
		const extradataListtemp = codes.filter(x => x.type === extratrakey); // await RayCodeAction.GetAllByFilter({ type: extratrakey });
		const extradataList = extradataListtemp.sort((a, b) => a.sortnumber - b.sortnumber);

		// BUG-174: extra-key 값은 문서의 extradata.<code> 경로에 저장되므로 필터 key 도 접두사를 포함해야 매칭된다.
		// (CustomHeader.js 컬럼 code 계산과 동일 규칙 — code: extratrakeyname + "." + x.code)
		// datatype 미지정(대부분의 PRODUCTEXTRAKEY) 시 STRING 폴백 — valtype=undefined 면 값 입력창이
		// 안 떠 addFilter 가 catch-all(BOOLEAN true)로 오분류한다(ProductInfoExra.getFType 기본 input 과 동일 규칙).
		extradataList.filter(x => filterList.push({ code: extratrakeyname + "." + x.code, name: x.name, type: x.datatype || "STRING" }))
		setCodeList(filterList);

		const optList = [];
		const oList = codes.filter(x => x.type === 'PRODUCTOPTION');  //await RayCodeAction.GetAllByFilter({ type: "PRODUCTOPTION" });
		oList.filter(x => optList.push({ code: x.name, title: x.name, type: 'OPTION' }));
		setPrdOptionList(optList);

		const wcOlist = [];
		const cOlist = codes.filter(x => x.type === 'WARRANTY' && x.group === 'WARRANTYTYPE'); //await RayCodeAction.GetAllByFilter({ type: "WARRANTY", group: "WARRANTYTYPE" });
		cOlist.filter(x => wcOlist.push({ code: x.code, title: x.name, type: 'OPTION' }));
		setWarOptionList(wcOlist);

		const wpOlist = [];
		const pOlist = codes.filter(x => x.type === 'WARRANTY' && x.group === 'WARRANTYPRODUCT'); // await RayCodeAction.GetAllByFilter({ type: "WARRANTY", group: "WARRANTYPRODUCT" });
		pOlist.filter(x => wpOlist.push({ code: x.code, title: x.name, type: 'OPTION' }));
		setWarProductList(wpOlist);
	}

	const onchange = (e) => {
		const { name, value, title } = e.target;
		let nc = codeList.find(x => x.code == value);

		if (value === "companyId" && title === "Company Info") {
			nc = codeList.find(x => x.code == "companyId" && x.name === "Company Info");
		}

		if (!nc) return;
		setValType(nc.type);
		// 주의: `title` 에 담기는 값은 표시 문구가 아니라 **선택한 필드의 코드**다(InputSelect2 가
		// 선택 옵션의 `code` 를 value 로 넘긴다). 아래 addFilter 가 이걸 칩의 `key` 로 그대로 쓴다.
		setSelOptions({ code: name, title: value });
		setFixListItem(nc.type == "FIXLIST" ? nc.fixlist : []);
	}

	const getPeriodMsg = (m) => {
		switch (m) {
			case "d": return t('common.label.days');
			case "w": return t('common.label.weeks');
			case "M": return t('common.label.months');
		}
	}


	// 작업중 prdtype 대소문자 구분없이 할 수 있는 방안.
	const addFilter = () => {
		if (!seloptions || !seloptions.title) {
			console.warn('[guard] addFilter blocked — no field selected', {
				handler: 'DeepSearch.addFilter',
				key: seloptions?.title,
				reason: 'seloptions.title is empty; ignoring add-filter attempt',
			});
			return;
		}
		let newChip;
		if (valtype == "STRING" || valtype == "NUMBER" || valtype == "OPTION" || valtype == "ERRORCODES" || valtype == "PARTLIST" || valtype == "CLAIM" || valtype == "WARRANTYTYPE" || valtype == "WARRANTYPRODUCT") {
			newChip = { key: seloptions.title, val: selval, valstr: selval, type: "STRING" };
		} else if (valtype == "OPERATOR" || valtype == "COUNTRY") {
			newChip = { key: seloptions.title, val: selval, valstr: resolveOperatorValStr(valtype == "OPERATOR" ? operators : CountryCode, selval), type: "STRING" };
		} else if (valtype == "STATUS") {
			newChip = { key: seloptions.title, val: selval, valstr: selval, type: "STRING" };
		} else if (valtype == "USER") {
			newChip = { key: seloptions.title, val: selval, valstr: selval, type: "STRING" };
		} else if (valtype == "LIKESTRING") {
			newChip = { key: seloptions.title, val: selval, valstr: selval, type: "LIKESTRING" };
		} else if (valtype == "FIXLIST") {
			newChip = { key: seloptions.title, val: selval, valstr: selval, type: "FIXLIST" };
		} else if (valtype == "DATETIME" || valtype == "DTONLY") {
			if (dtOptionVal.opt == "fix") {
				newChip = { key: seloptions.title, val: dtOptionVal, valstr: moment(dtOptionVal.s).format("YYYY-MM-DD") + " ~ " + moment(dtOptionVal.e).format("YYYY-MM-DD"), type: "DATETIME" };
			} else {
				newChip = { key: seloptions.title, val: dtOptionVal, valstr: "Last " + dtOptionVal.lastVal + " " + getPeriodMsg(dtOptionVal.lastValOpt), type: "DATETIME" };
			}
		} else {
			newChip = { key: seloptions.title, val: selvaltf, valstr: selvaltf ? "True" : "False", type: "BOOLEAN" };
		}

		// F-004: "한 항목당 칩 하나" 불변식 — 같은 key 의 칩이 이미 있으면 여기서 한 곳에서만
		// 병합(LIKESTRING)/교체(그 외)를 처리한다. 타입별 분기(위)는 칩 객체 생성까지만 담당한다.
		const existingIdx = filter.findIndex(x => x.key == newChip.key);
		if (existingIdx === -1) {
			setFilter([...filter, newChip]);
		} else if (newChip.type === "LIKESTRING") {
			const existing = filter[existingIdx];
			const merged = {
				...newChip,
				val: `${existing.val}, ${newChip.val}`,
				valstr: `${existing.valstr}, ${newChip.valstr}`,
			};
			const nextFilter = [...filter];
			nextFilter[existingIdx] = merged;
			setFilter(nextFilter);
		} else {
			console.warn('[guard] addFilter replaced existing chip', {
				handler: 'DeepSearch.addFilter',
				key: newChip.key,
				reason: 'chip for this key already exists; non-LIKESTRING types replace instead of merging',
			});
			const nextFilter = [...filter];
			nextFilter[existingIdx] = newChip;
			setFilter(nextFilter);
		}
		// F-002: 추가 성공 후에도 선택한 항목·타입은 유지한다. 값만 비워 연속 추가를 자연스럽게 한다.
		setSelVal("");
	}

	const delFilter = (f) => {
		setFilter(filter.filter(x => x.key != f.key))
	}

	const btnSearch = () => {
		dispatch({ type: dispatchType, dsfilters: filter });
		//callbackDs(filter); 
		//callbackDSClose(false);
	}

	const btnShowFilter = () => {
		setShowModal(true);
	}

	const btnClear = () => {
		// F-002: 전체 Clear 는 필터뿐 아니라 선택 상태·입력값·타입도 초기 상태로 되돌린다.
		setFilter([]);
		setSelOptions({ code: "", title: "" });
		setValType("STRING");
		setSelVal("");
		dispatch({ type: dispatchType, dsfilters: [] });
		callbackDSClose(false);
		//callbackDs(filter);
	}

	const getFilterOptionList = () => {
		// F-003: Select Key 목록을 화면에 보이는 이름 기준 사전순으로 정렬한다(로케일 인지 비교).
		// 각 옵션은 `{ code, title }` 형태이고 `title` 이 표시 이름이다(원본 정의의 `name` 이 여기로 들어온다).
		// DeepSearch 내 기존 정렬 선례(operator 드롭다운, 위 91행)와 동일한 방식을 따른다.
		return options
			.filter(x => !filter.map(m => m.key).includes(x.code))
			.sort((a, b) => (a.title || '').localeCompare(b.title || ''))
	}

	const btnDelFilter = () => {
		UpdateUserAdminFilters({ filters: allfilter.filter(x => x.id != nowuserfilter.id) });
		callbackchangeuserfilter({});
		btnClear();
	}

	return (
		<div className="card">
			<div className="card-header">
				<h3 className="mb-0">{t('common.label.deepSearch')} {nowuserfilter.title && " - " + nowuserfilter.title}</h3>
			</div>
			<div className="">
				<table className="table">
					<tbody>
						<tr>
							<td style={{ width: '50%', verticalAlign: "top" }}>
								<div>
									<div className="section">
										<div className="section-title">{t('common.button.addFilter')}</div>
										<ul className="listview simple-listview no-space border-0">
											<InputSelect2 options={{
												label: t('common.button.selectKey'),
												name: "seloptions",
												list: getFilterOptionList(),
												val: seloptions.title,
											}} onchange={onchange} editable={true} />
											{valtype == "OPERATOR" && <InputSelect2 options={{
												label: "Country",
												name: "seloperator",
												list: operators,
												val: seloperator,
											}} onchange={(e) => setSelVal(e.target.value)} editable={true} />}
											{valtype == "COUNTRY" && <InputSelect2 options={{
												label: "Country",
												name: "selcountry",
												list: CountryCode,
												val: selcountry,
											}} onchange={(e) => setSelVal(e.target.value)} editable={true} />}
											{valtype == "USER" && <InputSelect2 options={{
												label: "User",
												name: "seluser",
												list: adminusers,
												val: seluser,
											}} onchange={(e) => setSelVal(e.target.value)} editable={true} />}
											{valtype == "PARTLIST" && <InputSelect2 options={{
												label: "Part",
												name: "selpartlist",
												list: parts,
												val: selpartlist,
											}} onchange={(e) => setSelVal(e.target.value)} editable={true} />}
											{valtype == "FIXLIST" && <InputSelect2 options={{
												label: "Fixed List",
												name: "selFixListItem",
												list: fixListItem,
												val: selFixListItem,
											}} onchange={(e) => setSelVal(e.target.value)} editable={true} />}
											{valtype == "STATUS" && <InputSelect2 options={{
												label: "Country",
												name: "selstatus",
												list: RayStatuses,
												val: selstatus,
											}} onchange={(e) => setSelVal(e.target.value)} editable={true} />}
											{valtype == "CLAIM" && <InputSelect2 options={{
												label: "Claim Category",
												name: "selclaim",
												list: claims,
												val: selclaim,
											}} onchange={(e) => setSelVal(e.target.value)} editable={true} />}
											{valtype == "OPTION" && <InputSelect2 options={{
												label: "Option",
												name: "seloption",
												list: prdOptionList,
												val: selprdoption,
											}} onchange={(e) => setSelVal(e.target.value)} editable={true} />}
											{valtype == "WARRANTYTYPE" && <InputSelect2 options={{
												label: "Warranty Category",
												name: "selwarranty",
												list: warOptionList,
												val: selwarranty,
											}} onchange={(e) => setSelVal(e.target.value)} editable={true} />}
											{valtype == "WARRANTYPRODUCT" && <InputSelect2 options={{
												label: "Warranty Product",
												name: "selwarrantyproduct",
												list: warProductList,
												val: selwarrantyproduct,
											}} onchange={(e) => setSelVal(e.target.value)} editable={true} />}
											{(valtype == "STRING" || valtype == "NUMBER" || valtype == "LIKESTRING") && <InputBasicText options={{
												label: t('common.button.typeValue'),
												name: "selval",
												val: selval,
											}} onchange={(e) => setSelVal(e.target.value)} editable={true} />}
											{valtype == "LIKESTRING" && <small className="text-muted">{t('common.message.deepSearchCommaOr')}</small>}
											{(valtype == "DATETIME" || valtype == "DTONLY") && <div className="item nopadd">
												<div className="in">
													<select className="form-control" style={{ width: 80 }}
														onChange={(e) => setDtOptionVal({ ...dtOptionVal, opt: e.target.value })}>
														<option value="last">Latest</option>
														<option value="fix">Fix</option>
													</select>
													<div>
														{dtOptionVal.opt == "last" && <>
															<select className="form-control float-end"
																onChange={(e) => setDtOptionVal({ ...dtOptionVal, lastValOpt: e.target.value })}
																style={{ width: 80 }}
																value={dtOptionVal.lastValOpt}>
																<option value="d">Days</option>
																<option value="w">Weeks</option>
																<option value="M">Months</option>
															</select>
															<input type="number" min="1" max="100"
																value={dtOptionVal.lastVal}
																onChange={(e) => setDtOptionVal({ ...dtOptionVal, lastVal: e.target.value })}
																className="form-control float-end" style={{ width: 80 }}></input>
														</>}
														{dtOptionVal.opt == "fix" && <>
															<DatePicker
																className="form-control"
																dateFormat="yyyy-MM-dd"
																selected={moment(dtOptionVal.s).toDate()}
																onChange={(date) => {
																	if (moment(date).startOf('day').valueOf() != dtOptionVal.s)
																		setDtOptionVal({ ...dtOptionVal, s: moment(date).startOf('day').valueOf() })
																}} /> ~
															<DatePicker
																className="form-control"
																dateFormat="yyyy-MM-dd"
																selected={moment(dtOptionVal.e).toDate()}
																onChange={(date) => {
																	if (moment(date).startOf('day').valueOf() != dtOptionVal.e)
																		setDtOptionVal({ ...dtOptionVal, e: moment(date).startOf('day').valueOf() })
																}} />
														</>}
													</div>
												</div>
											</div>}
											{valtype == "BOOLEAN" && <div className="item nopadd">
												<div className="in">
													<div className="label"><strong>True/False</strong>{selvaltf}</div>
													<div className="form-check form-switch">
														<input className="form-check-input" type="checkbox"
															checked={selvaltf.toString() == "true"}
															id={"selvaltf"}
															name={"selvaltf"}
															value={selvaltf}
															onChange={(e) => { console.log(e.target.checked); setSelValTF(Boolean(e.target.checked)); }} />
														<label className="form-check-label" htmlFor={"selvaltf"} />
													</div>
												</div>
											</div>}
											{valtype == "STRING" && <>
												{(seloptions.code != "" && selval != "" && seloptions != "") && <button className="btn btn-block btn-primary" onClick={(e) => addFilter()}>{t('common.button.addFilter')}</button>}
												{!(seloptions.code != "" && selval != "" && seloptions != "") && <button className="btn btn-block btn-primary" onClick={(e) => addFilter()}>{t('common.button.addFilter')}</button>}
											</>}
											{valtype != "STRING" && <button className="btn btn-block btn-primary" onClick={(e) => addFilter()}>{t('common.button.addFilter')}</button>}
										</ul>
									</div>
								</div>

							</td>
							<td style={{ width: 24 }}>
								<div>
									<ion-icon name="arrow-forward-outline" size="large"></ion-icon>
								</div>

							</td>
							<td style={{ width: '50%', verticalAlign: "top" }}>
								<div>
									<div className="section">
										<div className="section-title">{t('common.label.filters')}</div>
										{filter.length == 0 && <div>{t('common.label.noFilter')}</div>}
										{(codeList.length > 0 && filter.length > 0) && <ul className="listview simple-listview no-space mb-2 border-top">
											{filter.map((x, idx) => {
												return <li key={idx} className="border-bottom p-0">
													<span>{codeList.find(y => y.code == x.key)?.name ?? x.key} = {x.valstr}</span>
													<button className="btn btn-sm btn-danger mt-0" onClick={() => delFilter(x)}>{t('common.button.delete')}</button>
												</li>
											})}
										</ul>}
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div className="card-footer">
				<div className="row">
					<div className="col ps-0">
						<div className="btn-group">
							<button
								className="btn btn-primary mb-0 mt-0"
								onClick={() => btnSearch()}>{t('common.button.search')}</button>
							<button
								className={filter.length > 0 ? "btn btn-info mb-0 mt-0" : "btn btn-info disabled mb-0 mt-0"}
								onClick={() => btnShowFilter()}>{t('common.button.saveFilter')}</button>
							{nowuserfilter && <RayDelButton callback={btnDelFilter} startMsg={t('common.button.deleteFilter')}
								css="btn btn-danger mb-0 mt-0"
								confirmMsg="Are you sure?" />}
							<button
								className="btn btn-success mb-0 mt-0"
								onClick={() => btnClear()}>{t('common.button.clear')}</button>
							<button className="btn btn-dark mt-0" onClick={() => callbackDSClose(false)}>{t('common.button.close')}</button>
						</div>
					</div>
				</div>
			</div>
			<DeepSearchFilterSave showModal={showModal}
				type={savefiltertype}
				filter={filter}
				filterset={nowuserfilter}
				callbackClose={() => setShowModal(false)}
				callbackSave={(data) => callbackchangeuserfilter(data)} />
		</div>
	);
}

const mapState = (state) => {
	const user = state.AuthReducer.user;
	//var dsfilters = state.ProductReducer.dsfilters;
	const companies = state.CompanyReducer.companies;
	const users = state.AdminUserReducer.users;
	const partitems = state.ProductPartReducer.items;
	const clist = state.RayCodeReducer.items;
	return { user, users, companies, partitems, clist };
};

const mapDispatch = (dispatch) => ({
	UpdateUserAdminFilters: (uinfo) => dispatch(AuthAction.UpdateUserAdminFilters(uinfo)),
	GetUserAll: () => dispatch(AdminUserAction.GetUserAll()),
	GetPartAll: () => dispatch(ProductPartAction.GetAll()),
	//GetCompany: () => dispatch(CompanyAction.GetCompany())
});

export default connect(mapState, mapDispatch)(DeepSearch);